
'use strict';

var Geometry = require('../../../utils/Geometry');
var LabelConverter = require('../../../utils/LabelConverter');
var _ = require('lodash');

L.Path.include({
  noHide: function() {
    if(this.label) {
      this
        .off('mouseover', this._showLabel, this)
        .off('mousemove', this._moveLabel, this)
        .off('mouseout remove', this._hideLabel, this);
    }
    return this;
  },
});

var _sanitize = function(text) {
  return _.escape(text);
};

module.exports = {
  setLabels : function(showImmediately) {
    if(this.layer.annotationId) {

      var leafletLayer = this.leafletLayer;
      var props = this.layer.data.properties;
      var options = { className : 'sb-measurement-label', noHide : true };
      var wrapLabel = function(text) {
        return '<div class="content-wrapper">' +
          '<div class="sb-measurement-label-text content" {{style}}>' +
          '<div class="content-wrapper-label">' +
          _sanitize(text) +
          '</div>' +
          '</div></div>';
      };
      var type = this.layer.type;
      var addLabel, removeLabel;
      var contents, color;

      leafletLayer.unbindLabel(); // Clean state before

      switch(type) {
      case 'rectangle':
      case 'polygon':
      case 'circle':
        if (props.showMeasurements && props.area) {
          console.log('Area: ', props.area);
          var area = LabelConverter.getLabel(props.area, 'area', props.units);

          contents = wrapLabel(area);
          if(leafletLayer.options && leafletLayer.options.color) {
            color = leafletLayer.options.color;
            contents = contents.replace('{{style}}', 'style="border-color:' + color + '"');
          } else {
            contents = contents.replace('{{style}}', '');
          }
          leafletLayer.bindLabel(contents, options).noHide();
          addLabel = function() {
            leafletLayer._showLabel({
              latlng : Geometry.centroid(this.layer.type, leafletLayer.toGeoJSON())
            });
          }.bind(this);
          removeLabel = function() {
            if(leafletLayer.label) {
              leafletLayer._hideLabel();
            }
          }.bind(this);
          this.on('add', addLabel);
          this.on('dragend', addLabel);
          this.on('remove', removeLabel);
          this.on('dragstart', removeLabel);
          if(showImmediately) {
            addLabel();
          }
        }
        break;

      case 'marker':
        if(props.text) {
          this.leafletLayer.bindLabel(_sanitize(props.text), {
            className : 'sb-map-marker-text',
            noHide : true
          });
          addLabel = function() {
            leafletLayer.showLabel();
          };
          removeLabel = function() {
            leafletLayer.hideLabel();
          };
          this.on('add', addLabel);
          this.on('dragend', addLabel);
          this.on('remove', removeLabel);
          this.on('dragstart', removeLabel);
          if(showImmediately) {
            addLabel();
          }
        }
        break;
      case 'polyline':
        if(props.showMeasurements && props.distance) {
          var distance = LabelConverter.getLabel(props.distance, 'distance', props.units);

          contents = wrapLabel(distance);
          if(leafletLayer.options && leafletLayer.options.color) {
            color = leafletLayer.options.color;
            contents = contents.replace('{{style}}', 'style="border-color:' + color + '"');
          } else {
            contents = contents.replace('{{style}}', '');
          }

          leafletLayer.bindLabel(contents, options).noHide();

          addLabel = function() {
            var points = leafletLayer.getLatLngs();
            var midPoint = points[Math.floor(points.length / 2)];
            leafletLayer._showLabel({
              latlng : midPoint
            });
          }.bind(this);
          removeLabel = function() {
            if(leafletLayer.label) {
              leafletLayer._hideLabel();
            }
          }.bind(this);
          this.on('add', addLabel);
          this.on('dragend', addLabel);
          this.on('remove', removeLabel);
          this.on('dragstart', removeLabel);
          if(showImmediately) {
            addLabel();
          }
        }
        break;
      case 'overlay':
      case 'text':
        // No labels for overlays or texts themselves
        break;
      default:
        console.error('No label for layer', this);
      }
    }
  },

  setLabelEvents : function() {
    var layer = this;
    var leafletLayer = this.leafletLayer;
    leafletLayer.on('labels:show', function() {
      if(!leafletLayer.label) {
        layer.setLabels(true);
      }
    });
    leafletLayer.on('labels:hide', function() {
      if(leafletLayer.label) {
        leafletLayer.unbindLabel();
      }
    });

    leafletLayer.on('measurements:updated', function() {
      layer.setLabels(true);
    });

    leafletLayer.on('color:changed', function() {
      layer.setLabels(true);
    });

    leafletLayer.on('layer:moved', function() {
      layer.setLabels(true);
    });
  }

};



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/edit/base/mixins/LabelMixin.js